fd.reminders = {
    init: function() {
        $("input[name=postcode]").postcode();
    }
}